// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "style." + "11b8ef5b59d25c4c4cde" + ".css";
};